export default __webpack_public_path__ + "static/media/android.b9b7a799.svg";